import { X } from "lucide-react";
import type { FeatureItem } from "../PricingSection.data";

type TextItem = string;

function Marquee({
  items,
  reverse = false,
  variant,
}: {
  items: TextItem[] | FeatureItem[];
  reverse?: boolean;
  variant: "red" | "blue" | "pink";
}) {
  const styles =
    variant === "red"
      ? { wrap: "border border-brand-red/40 bg-brand-red/5", icon: "text-brand-red" }
      : variant === "blue"
      ? { wrap: "border border-brand-blue/40 bg-brand-blue/5", icon: "text-brand-blue" }
      : { wrap: "", icon: "" };
  const inlinePink =
    variant === "pink"
      ? { borderWidth: 1, borderStyle: "solid" as const, borderColor: "#dd4aa666", backgroundColor: "#dd4aa60D" }
      : undefined;
  const pinkIcon = variant === "pink" ? { color: "#dd4aa6" } : undefined;

  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-background to-transparent" />
      <div
        className="group flex overflow-hidden"
        style={{
          maskImage: "linear-gradient(90deg, transparent, black 5%, black 95%, transparent)",
          WebkitMaskImage: "linear-gradient(90deg, transparent, black 5%, black 95%, transparent)",
        }}
      >
        <div
          className={`flex w-max shrink-0 ${reverse ? "animate-marquee-reverse" : "animate-marquee"} group-hover:[animation-play-state:paused]`}
          style={{ willChange: "transform", WebkitBackfaceVisibility: "hidden", backfaceVisibility: "hidden", transform: "translateZ(0)" }}
        >
          {[0, 1].map((dup) => (
            <div key={dup} className="flex shrink-0 gap-6 pr-6" aria-hidden={dup === 1}>
              {items.map((item) => {
                if (typeof item === "string") {
                  return (
                    <div
                      key={item}
                      className={`flex shrink-0 items-center gap-4 rounded-full px-8 py-4 text-base sm:text-lg text-foreground ${styles.wrap}`}
                      style={inlinePink}
                    >
                      <X className={`h-7 w-7 ${styles.icon}`} style={pinkIcon} />
                      <span className="whitespace-nowrap">{item}</span>
                    </div>
                  );
                }
                const { icon: Icon, label } = item;
                return (
                  <div
                    key={label}
                    className={`flex shrink-0 items-center gap-4 rounded-full px-8 py-4 text-base sm:text-lg text-foreground ${styles.wrap}`}
                    style={inlinePink}
                  >
                    <Icon className={`h-7 w-7 ${styles.icon}`} style={pinkIcon} />
                    <span className="whitespace-nowrap">{label}</span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export { Marquee };
